/*
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
 */

import { useCollaboraStore } from "@/stores/collabora.js";
import { useConfigStore } from "@/stores/config.js";

// Mapping of MIME types to specialized text editor routes
const textEditorRouteMapping = {
  "text/x-markdown": "md-editor",
  "text/x-web-markdown": "md-editor",
  "text/html": "html-editor",
  "application/json": "json-editor",
  "text/plain": "text-editor",
  "application/x-sh": "text-editor",
  "text/x-sh": "text-editor",
  "text/xml": "text-editor",
  "application/xml": "text-editor",
  "text/x-perl": "text-editor",
  "text/x-python": "text-editor",
  "text/x-java-source": "text-editor",
  "text/x-c": "text-editor",
  "text/x-c++": "text-editor",
  "text/x-csharp": "text-editor",
  "text/x-php": "text-editor",
  "text/x-ruby": "text-editor",
  "text/x-scala": "text-editor",
  "text/x-groovy": "text-editor",
  "text/x-kotlin": "text-editor",
  "text/x-sql": "text-editor",
  "text/x-yaml": "text-editor",
  "text/yaml": "text-editor",
  "application/x-yaml": "text-editor",
  "text/css": "text-editor",
  "text/javascript": "text-editor",
  "application/javascript": "text-editor",
  "application/x-javascript": "text-editor",
  "text/typescript": "text-editor",
  "application/typescript": "text-editor",
};

export function getTargetRoute(item) {
  const config = useConfigStore();
  const collaboraStore = useCollaboraStore();
  const mimeType = item.content.mimeType;

  if (!config.OPEN_PDF_WITH_COLLABORA && mimeType === "application/pdf") {
    return { name: "consultation-pdf", params: { id: item.id } };
  } else if (mimeType.startsWith("image/")) {
    return { name: "consultation-image", params: { id: item.id } };
  } else if (mimeType.startsWith("video/")) {
    return { name: "consultation-video", params: { id: item.id } };
  } else if (textEditorRouteMapping[mimeType]) {
    return { name: textEditorRouteMapping[mimeType], params: { id: item.id } };
  } else if (mimeType.startsWith("text/")) {
    return { name: "text-editor", params: { id: item.id } };
  } else if (collaboraStore.checkIfExists(mimeType, "edit")) {
    return {
      name: "edit-collabora",
      params: { action: "edit", id: item.id },
    };
  } else if (collaboraStore.checkIfExists(mimeType, "view")) {
    return {
      name: "edit-collabora",
      params: { action: "view", id: item.id },
    };
  } else if (collaboraStore.checkIfExists(mimeType, "view_comment")) {
    return {
      name: "edit-collabora",
      params: { action: "view", id: item.id },
    };
  }
  return { name: "consultation-pdf", params: { id: item.id } };
}

export function nodeToMenuItem(favorite) {
  if (!favorite.path) {
    console.warn("nodeToMenuItem, favorite has no path", favorite);
    return;
  }

  let target = "";
  const sitePath = favorite.path.elements.find(
    (element) => element.nodeType === "st:site",
  );
  let route;
  if (favorite.isFolder) {
    route = {
      name: "navigation-dossier",
      params: { id: sitePath.name, FolderId: favorite.id },
    };
  } else {
    route = getTargetRoute(favorite);
    if (route.name === "edit-collabora") {
      target = "_blank";
    }
  }
  if (sitePath?.name) {
    return {
      label: favorite.name,
      icon: favorite.isFolder ? "ri-folder-2-line" : "ri-file-line",
      class: "menu-item responsive-text",
      target: target,
      to: route,
    };
  }
}
